import React from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import {
  appointmentPostAction,
  getAppoitmentList,
} from "../../actions/appointment";
import { Form, Formik } from "formik";
import FormikControl from "../../components/WraapperComponent/FormikControl";
import { useSelector } from "react-redux";
const AppointmentPopupForPractitioner = ({
  closePopup,
  selectedSlot,
  startDate,
  endDate,
  setIsLoading,
  id,
  name,
  refreshCalendar,
}) => {
  const dispatch = useDispatch();
  const patientList = useSelector((state) => state.appointment.patientList);
  const isoToMySQL = (isoDateTime) => {
    const date = new Date(isoDateTime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const initialValues = {
    description: "",
    patient: "",
  };

  const validationSchema = Yup.object({
    patient: Yup.string().required("This field is required"),
    description: Yup.string(),
  });

  // Function to convert MySQL datetime format to ISO 8601 format

  const handleBook = (values) => {
    const email = patientList.find((x) => x.value == values.patient)?.email;
    let params = {
      params: {
        action: "addAppointment",
        start_date: isoToMySQL(selectedSlot.start),
        end_date: isoToMySQL(selectedSlot.end),
        practitioner_id: id,
        title: "Appointment with " + email,
        patient_email: email,
        description: values.description,
        patient_id: values.patient,
      },
    };

    setIsLoading(true);
    dispatch(
      appointmentPostAction(params, () => {
        closePopup();
        window.location.reload();
      })
    );
  };

  return (
    <Modal size="lg" show={true}>
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">Confirm</h5>
          <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
        </div>
      </Modal.Header>

      <Modal.Body>
        <h5>
          My Herbal Pharmacy Consultation from{" "}
          {selectedSlot.start.toLocaleDateString("en-US", {
            month: "long",
            year: "numeric",
            day: "numeric",
            weekday: "long",
            hour: "numeric",
            minute: "numeric",
            hour12: true,
          })}{" "}
          to{" "}
          {selectedSlot.end.toLocaleDateString("en-US", {
            month: "long",
            year: "numeric",
            day: "numeric",
            weekday: "long",
            hour: "numeric",
            minute: "numeric",
            hour12: true,
          })}
        </h5>
        <div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleBook}
          >
            {({ errors, touched, setFieldValue, handleBlur }) => {
              return (
                <Form>
                  <div className="row">
                    <div className="col-sm-12">
                      <FormikControl
                        control="dropdown"
                        label="Patient *"
                        name="patient"
                        handleBlur={handleBlur}
                        hasError={errors.state && touched.state}
                        options={patientList}
                      />
                    </div>
                    <div className="col-sm-12">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="Descriprion "
                        name="description"
                        handleBlur={handleBlur}
                        hasError={errors.description && touched.description}
                      />
                    </div>
                  </div>
                  <div className="submit-section justify-content-end d-flex">
                    <button type="submit" className="btn-orange mr-4">
                      Book
                    </button>
                    <button
                      type="button"
                      style={{ width: "100px" }}
                      className="btn-orange"
                      onClick={() => {
                        closePopup();
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default AppointmentPopupForPractitioner;
